import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";

/*
 *  Header section
 *
 *  Version:
 *    1.0.0 - 2020/10/20
 */
import { findTarget, delegate } from '../../tools/utilities/event-tools';
import { documentDisableScroll, documentEnableScroll } from '../../tools/layout/document';
import { CLASS_SEARCH_OPEN, CLASS_MENU_OPEN, CLASS_STICKY } from '../../tools/constants/classes';
import { responsiveMediaBelow } from '../../settings/responsive';
import { getCurrentCart, ON_CART_FINISHED } from '@process-creative/slate-theme-tools/dist/cart'; // Selectors

var SELECTOR_MOBILE_MENU_TRIGGER = '[data-mobile-menu-toggle]';
var SELECTOR_HEADER = '[data-header]';
var SELECTOR_SEARCH_TRIGGER = '[data-search-toggle]';
var SELECTOR_SEARCH_INPUT = '[data-search-input]';
var SELECTOR_CART_COUNT = '[data-header-cart-counter]';
var SCROLL_DISTANCE = 4; // Functions

var open = function open(clazz) {
  // Add body classes
  document.body.classList.add(clazz); // Disable scroll

  if (clazz != CLASS_SEARCH_OPEN) documentDisableScroll();
};

var close = function close(clazz) {
  // Remove body classes
  document.body.classList.remove(clazz); // Enable scroll

  if (clazz != CLASS_SEARCH_OPEN) documentEnableScroll();
};

var searchToggle = function searchToggle(e) {
  e.preventDefault(), e.stopPropagation(); // Only run this on mobile - laptop sizes

  if (responsiveMediaBelow('MEDIUM')) return;
  var headerContainer = findTarget(e, SELECTOR_HEADER);
  if (!headerContainer) return;

  if (document.body.classList.contains(CLASS_SEARCH_OPEN)) {
    return close(CLASS_SEARCH_OPEN);
  }

  open(CLASS_SEARCH_OPEN);
};

var menuToggle = function menuToggle(e) {
  e.preventDefault(), e.stopPropagation();
  if (document.body.classList.contains(CLASS_MENU_OPEN)) return close(CLASS_MENU_OPEN);
  open(CLASS_MENU_OPEN);
};

var onCartUpdate = function onCartUpdate() {
  var countElement = document.querySelector(SELECTOR_CART_COUNT);
  if (!countElement) return;
  var cart = getCurrentCart();
  var itemsExcludingBundleChildren = cart === null || cart === void 0 ? void 0 : cart.items.filter(function (i) {
    var _i$properties;

    return !((_i$properties = i.properties) !== null && _i$properties !== void 0 && _i$properties._isChildProduct);
  });
  countElement.innerHTML = (itemsExcludingBundleChildren === null || itemsExcludingBundleChildren === void 0 ? void 0 : itemsExcludingBundleChildren.length) || 0;
};

$(document).on(ON_CART_FINISHED, function (e) {
  return onCartUpdate();
}); // Initialise search toggle

document.querySelectorAll(SELECTOR_SEARCH_TRIGGER).forEach(function (element) {
  element.addEventListener('click', searchToggle);
}); // On mobile menu trigger click

delegate({
  element: document.documentElement,
  selector: SELECTOR_MOBILE_MENU_TRIGGER,
  event: 'click',
  callback: menuToggle
}); // Alessio stuff

var HEADER_CONTAINER = '[data-header]';
var CLASS_SCROLLED = 'has-scrolled';
document.querySelectorAll(HEADER_CONTAINER).forEach(function (header) {
  var topbarHeight = header.clientHeight;

  var setHeaderState = function setHeaderState() {
    var top = window.pageYOffset; // Visible state of the header

    if (top > topbarHeight + SCROLL_DISTANCE) {
      header.classList.add(CLASS_STICKY);
      document.body.classList.add(CLASS_SCROLLED);
    } else {
      header.classList.remove(CLASS_STICKY);
      document.body.classList.remove(CLASS_SCROLLED);
    }

    requestAnimationFrame(function () {
      return setHeaderState();
    });
  };

  setHeaderState();
});